module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buch-66a4407a85a50d89a925ccccc02bf1ef.png";